module.exports = __webpack_public_path__ + "static/media/chiropractic.2624d0d4.svg";